// extracted by mini-css-extract-plugin
module.exports = {"noResult":"TableMobile_noResult__1Tx_c","error":"TableMobile_error__1v5n7","skeleton":"TableMobile_skeleton__2dyJb","title":"TableMobile_title__1aKUd"};